<template>
  <div>
    <section-title
      icon="fa fa-clipboard-list-check"
      title="Resumen de Información General"
      title-class="font-14"
      class="mt-4"
    />
    <div class="row">
      <div class="col-md-4">
        <div class="py-2 px-3 mt-3 bg-secondary-3">
          <label class=" font-14 mt-3 mb-0 font-weight-normal">
            Categoría:
          </label>
          <custom-drop-down
            fieldkey="id"
            fieldname="name"
            v-model="categoryType"
            :options="categoryTypes"
            @input="onCategoryTypeChange"
            :clearable="false"
          ></custom-drop-down>
        </div>
      </div>
      <div class="col-md-4">
        <detail-general-info-panel
          :content="totalLabel"
          :count="informationSummaryTotal"
          :has-badge="false"
          background="bg-secondary-16"
          image="eden-egreso-total.svg"
        />
      </div>
      <div class="col-md-4">
        <detail-general-info-panel
          content="Diferencia año anterior"
          :count="informationSummaryTotalLY"
          :has-badge="true"
          :badge-percent="informationSummaryPercentDiff"
          image="eden-egreso-dif-anio-anterior.svg"
        />
      </div>
    </div>

    <summary-by-category :summary="summary"></summary-by-category>

    <detail-snapshot
      title="Detalle de Personal"
      :filter-manager-config="filterManagerConfig"
      :filters="filters"
      :data="resultData"
      :paging-list="pagingList"
      :page-size="pageSize"
      :page-size-mobile="pageSizeMobile"
      @on-search="onHandlerSearch"
      @on-change-page="goToPageHandler($event)"
      @on-selected-paging="onSelectedPagingHandler($event)"
      @on-print="printCategoryDetail">
      <div v-for="(row, idx) of resultData.result" :key="`result-${idx}`" class="py-1">
        <component :is="resultRow_component" :category-type="categoryType" :data="row" class="mb-3"></component>
      </div>
    </detail-snapshot>
  </div>
</template>

<script>
import DetailGeneralInfoPanel from '@/views/eden/shared/components/DetailGeneralInfoPanel.vue'
import Service from '@/services/api/edenpersonnel.api'
import CodeService from '@/services/api/code.api'
import SectionTitle from 'SectionTitle'
import CustomDropDown from '@/components/common/form/CustomDropDown.vue'
import edenPersonnelCategoryType from '@/utils/constants/edenPersonnelCategoryType'
import SummaryByCategory from './SummaryByCategory.vue'
import DetailSnapshot from '../../shared/components/DetailSnapshot.vue'
import ResultRowDetail from './ResultRowDetail.vue'
import ReportServices from "@/modules/report/api";
import DocumentServices from "@/modules/report/document";

export default {
  name: 'ReportDetail',
  components: {
    DetailGeneralInfoPanel,
    SectionTitle,
    CustomDropDown,
    SummaryByCategory,
    DetailSnapshot,
    ResultRowDetail,
  },
  inject: ['mediaQueries'],
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    filters: {
      qualification: null,
      disciplineType: null,
      category: null,
      company: null,
      personnelName: null,
    },
    collections: {
      qualifications: [],
      companies: [],
      disciplineTypes: [],
      categories: [],
    },
    summary: null,
    informationSummaryTotal: 0,
    informationSummaryTotalLY: 0,
    informationSummaryPercentDiff: 0,
    percentInfo: 0,
    totalLabel: null,
    categoryType: null,
    categoryTypes: [],
    personnelNames: [],
    resultRow_component: 'ResultRowDetail',
    resultData: {
      result: {},
      pagination: {},
      selectedPaging: null,
    },
  }),
  computed: {
    pageSize() {
      return 20
    },
    pageSizeMobile() {
      return 5
    },
    filterManagerConfig() {
      switch (this.categoryType?.id) {
        case edenPersonnelCategoryType.Specialist:
          return [
            {
              name: 'disciplineType',
              component: 'custom-drop-down',
              fieldKey: 'id',
              fieldName: 'name',
              label: 'Disciplina:',
              placeholder: 'Seleccione',
              class: 'col-12 col-md-4',
              clearable: true,
              options: this.collections.disciplineTypes,
              value: this.filters.disciplineType,
              disabled: this.collections.disciplineTypes?.length <= 0,
            },
            {
              name: 'company',
              component: 'custom-drop-down',
              fieldKey: 'id',
              fieldName: 'name',
              label: 'Corporación:',
              placeholder: 'Seleccione',
              class: 'col-12 col-md-4',
              clearable: true,
              options: this.collections.companies,
              value: this.filters.company,
              disabled: this.collections.companies?.length <= 0,
              onChanged: this.onChangedCompany,
            },
            {
              name: 'personnelName',
              component: 'custom-drop-down',
              fieldKey: 'id',
              fieldName: 'name',
              label: 'Nombre de Especialista:',
              placeholder: 'Seleccione',
              class: 'col-12 col-md-4',
              clearable: true,
              options: this.personnelNames,
              value: this.filters.personnelName,
              disabled: this.personnelNames?.length <= 0 ||
                this.personnelNames?.length == 1,
            },
          ];
        case edenPersonnelCategoryType.Master:
        case edenPersonnelCategoryType.Assistance:
        default:
          return [
            {
              name: 'category',
              component: 'custom-drop-down',
              fieldKey: 'name',
              fieldName: 'name',
              label: 'Categoría:',
              placeholder: 'Seleccione',
              class: 'col-12 col-md-4',
              clearable: true,
              options: this.collections.categories,
              value: this.filters.category,
              disabled: this.collections.categories?.length <= 0,
            },
            {
              name: 'qualification',
              component: 'custom-drop-down',
              fieldKey: 'id',
              fieldName: 'name',
              label: 'Calificación:',
              placeholder: 'Seleccione',
              class: 'col-12 col-md-4',
              clearable: true,
              options: this.collections.qualifications,
              value: this.filters.qualification,
              disabled: this.collections.qualifications?.length <= 0,
            },
            {
              name: 'personnelName',
              label: this.categoryType?.id == edenPersonnelCategoryType.Master ? 'Nombre de Maestro/SSN:' : 'Nombre de Asistente de Servicio/SSN:',
              component: 'CustomInput',
              class: 'col-12 col-md-4',
              value: this.filters.personnelName,
              placeholder: this.categoryType?.id == edenPersonnelCategoryType.Master ? 'Escriba nombre del maestro o SSN' : 'Escriba nombre del asistente o SSN',
              type:'string'
            },
          ];
      }
    },
    pagingList() {
      return [
        {
          id: 20,
          name: 20,
        },
        {
          id: 40,
          name: 40,
        },
        {
          id: 60,
          name: 60,
        },
        {
          id: 80,
          name: 80,
        },
        {
          id: 100,
          name: 100,
        },
      ]
    },
    edenMasterId() {
      return this.$route.params.id
    },
    computePercentage() {
      if (
        this.summary.schoolReportedCount === 0 ||
        this.summary.schoolReportedLastYearDifferenceCount === 0
      )
        return 0

      let difference = Math.abs(
        this.summary.schoolReportedLastYearDifferenceCount -
          this.summary.schoolReportedCount
      )

      let maxValue = Math.max(
        this.summary.schoolReportedLastYearDifferenceCount,
        this.summary.schoolReportedCount
      )

      return Math.floor(Math.abs((difference * 100) / maxValue))
    },
  },
  watch: {
    mediaQueries: {
      immediate: true,
      async handler() {
        if (this.mediaQueries.mobile) {
          this.resultData.pagination.pageSize = this.pageSizeMobile;
          this.$emit('on-search');
          return;
        }
        this.resultData.pagination.pageSize = this.pageSize
      },
    },
  },
  async mounted() {
    await this.getCategoryTypes()
    this.onCategoryTypeChange()
  },
  methods: {
    async printCategoryDetail() {
      const payload = {
        edenMasterId: this.edenMasterId,
        categoryTypeId: this.categoryType.id,
        categoryName: this.filters.category?.name,
        qualificationId: this.filters.qualification?.id,
        disciplineTypeId: this.filters.disciplineType?.id,
        companyId: this.filters.company?.id,
        personnelName: this.filters.personnelName,
      }

      await ReportServices.getReport('printcategorydetail', payload)
        .then((res) => DocumentServices.Download(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error')
        })
    },
    async getCategoryTypes() {
      var data = await CodeService.getEdenPersonnelCategoryTypes()
      this.categoryTypes = data.data
      this.categoryType = data.data[0]
    },
    getSummary() {
      var payload = {
        edenMasterId: this.edenMasterId,
        categoryTypeId: this.categoryType.id,
      }
      Service.getSummary(payload).then((data) => {
        let result = data.data
        this.summary = result.resultRows
        this.informationSummaryTotal = result.totalQuantity
        this.informationSummaryTotalLY = result.lastYearQuantity
        this.informationSummaryPercentDiff = Math.round(
          result.percentDifference
        )
      })
    },
    getFilters() {
      this.clearFilters()
      var payload = {
        edenMasterId: this.edenMasterId,
        categoryTypeId: this.categoryType.id,
      }
      Service.getFilters(payload).then((res) => {
        if (res) {
          this.collections = res.data.filters
        }
      })
    },
    clearFilters() {
      this.filters.qualification = null
      this.filters.disciplineType = null
      this.filters.category = null
      this.filters.company = null
      this.filters.personnelName = null
      this.personnelNames = []
    },
    async onHandlerSearch() {
      this.resultData.pagination.currentPage = 1
      await this.searchDetail()
    },
    async goToPageHandler(page) {
      this.resultData.pagination.currentPage = page
      await this.searchDetail()
    },
    async onSelectedPagingHandler(pageSize) {
      if (pageSize) {
        this.resultData.pagination.currentPage = 1
        this.resultData.pagination.pageSize = pageSize
        await this.searchDetail()
      }
    },
    async onCategoryTypeChange() {
      if (this.categoryType.id == edenPersonnelCategoryType.Assistance) {
        this.totalLabel = 'Total de asistentes de servicio'
      }
      if (this.categoryType.id == edenPersonnelCategoryType.Specialist) {
        this.totalLabel = 'Total de especialistas'
      }
      if (this.categoryType.id == edenPersonnelCategoryType.Master) {
        this.totalLabel = 'Total de maestros'
      }
      this.getSummary()
      this.getFilters()
      if (!this.resultData.selectedPaging) {
        this.resultData.selectedPaging = this.pagingList.find((x) => x.id == this.pageSize);
      }
      await this.searchDetail();
    },
    async searchDetail() {
      var val = this.filters.personnelName
      if (this.categoryType.id == edenPersonnelCategoryType.Specialist) {
        val = this.filters.personnelName?.id
      }

      const params = {
        edenMasterId: new Number(this.edenMasterId),
        categoryTypeId: this.categoryType?.id,
        disciplineTypeId: this.filters.disciplineType?.id,
        qualificationId: this.filters.qualification?.id,
        categoryName: this.filters.category?.name,
        companyId: this.filters.company?.id,
        personnelName: val,
        pageIndex: this.resultData.pagination.currentPage,
        pageSize: this.resultData.pagination.pageSize
      };

      await Service.searchDetail(params).then(({ data }) => {
        this.resultData = {
        ...this.resultData,
        result: data.data,
        pagination: {
            ...this.resultData.pagination,
            totalItemCount: data.totalItemCount,
            pageCount: data.pageCount,
            currentPage: data.currentPage,
            count: data.count,
            pageSize: this.resultData.pagination.pageSize
          },
        };
      });
    },
    async onChangedCompany() {
      this.personnelNames = []
      this.filters.personnelName = null
      this.getPersonnelNames()
    },
    getPersonnelNames() {
      var payload = {
        edenMasterId: this.edenMasterId,
        categoryTypeId: this.categoryType.id,
        companyId: this.filters.company?.id
      }
      Service.getPersonnelNames(payload).then((res) => {
        this.personnelNames = res.data
          if (res.data.length == 1) {
            this.filters.personnelName = res.data[0]
          }
      })
    },
  },
}
</script>
<style scoped>
.input-label {
  font-weight: normal !important;
}
</style>
